import { Injectable } from '@angular/core';

/**
 * UserServices
 *
 * Ce service devrait être un pipe mais regroupe un ensemble de fonctions utiles
 */
@Injectable({
  providedIn: 'root',
})
export class UtilsServices {
  /**
   * Logger
   */
  // private logger: LoggerWrapper;

  /**
   * Constructeur
   *
   * Crée une instance de UtilsServices.
   */
  constructor() {
    // private loggerFactory: LoggerFactory
    // this.logger = this.loggerFactory.getInstance(this);
  }

  getTodayKey() {
    return new Date().getDate() + '-' + new Date().getMonth() + '-' + new Date().getFullYear();
  }
  /**
   * Méthode pour mettre la premiere lettre en majuscule
   */
  capitalizeFirstLetter(text) {
    return text.charAt(0).toUpperCase() + text.substr(1).toLowerCase();
  }

  /**
   * Convertir le format HH:MM en minutes
   */
  convertToMinutes(text: string): number {
    const a = text.split(':'); // split it at the colons
    // Hours are worth 60 minutes.
    return +a[0] * 60 + +a[1];
  }

  /**
   * Fusion de deux objets
   */
  mergeObject(obj1, obj2) {
    // this.logger.log('mergeObject');
    // this.logger.log('obj1 : ', obj1);
    // this.logger.log('obj2 : ', obj2);
    let result = {};
    for (let key in obj1) result[key] = obj1[key];
    for (let key in obj2) result[key] = obj2[key];
    return result;
  }

  /**
   * Converti le timestamp en hh:mm:ss
   *
   * @param {any} secs timesptamp
   * @returns heure formatté
   * @memberof ChronosProvider
   */
  hhmm(secs: number): string {
    if (secs == undefined) {
      return '--:--';
    }
    let minutes = Math.floor(secs / 60);
    secs = secs % 60;
    let hours = Math.floor(minutes / 60);
    minutes = minutes % 60;

    if (secs > 30) minutes++;

    // On met par défaut 1 minute si le chrono a été lancé moins de 30 secondes
    if (hours == 0 && minutes == 0 && secs <= 30) minutes++;

    return this.pad(hours) + ':' + this.pad(minutes);
  }

  public pad(num: number): string {
    return num.toString().padStart(2, '0');
  }

  public ldapTimestampToDate(ldapTimestamp: bigint) {
    const unixTimestamp = this.ldapTimestampToUnixTimestamp(ldapTimestamp);
    return new Date(Number(unixTimestamp));
  }

  public ldapTimestampToUnixTimestamp(ldapTimestamp: bigint) {
    const epochDiff: bigint = 116444736000000000n;
    return (ldapTimestamp - epochDiff) / 10000n;
  }
}
